import { useCallback } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { appEnv } from '../lib/env';
import { useAuth } from './useAuth';

export function useAppLogout(): () => void {
  const { keycloak } = useKeycloak();
  const { signout } = useAuth();

  return useCallback((): void => {
    signout();
    keycloak.clearToken();
    keycloak.logout({ redirectUri: appEnv.appUrl || globalThis.location.origin }).catch(() => {});
  }, [keycloak, signout]);
}
